'use client';

import React from 'react';
import { ISolicitationEntry } from '../../../../../contentful/types/ISolicitationEntry';
import { PageLayout } from '../../../../shared/layout/page/PageLayout';
import SolicitationDetailsHeader from './SolicitationDetailsHeader';
import SolicitationDetailsContent from './SolicitationDetailsContent';
import { ISiteSectionEntry } from '../../../../../contentful/types/ISiteSection';
import { CORPORATE_SITE_SECTION_ID } from '../../../../../contentful';

interface ISolicitationDetailsPage {
	solicitation: ISolicitationEntry;
	siteSection?: ISiteSectionEntry;
}

export default function SolicitationDetailsPage({
	solicitation,
	siteSection,
}: ISolicitationDetailsPage) {
	return (
		<PageLayout siteSection={siteSection}>
			<SolicitationDetailsHeader
				siteSectionId={siteSection?.fields.id || CORPORATE_SITE_SECTION_ID}
				solicitation={solicitation}
			/>

			<SolicitationDetailsContent solicitation={solicitation} />
		</PageLayout>
	);
}
